// Service für Kennzeichensuche-API Calls
import { apiClient } from './api';
import { KennzeichensucheRequest, KennzeichensucheResponse } from '../types/kennzeichen';

const BASE_URL = '/kennzeichen';

export const KennzeichenService = {
  /**
   * Führt eine Kennzeichensuche durch (POST /api/kennzeichen/suche).
   * Hauptvariante für das GUI.
   *
   * @param request Suchparameter für die Kennzeichensuche
   * @returns Antwort mit gefundenen Kennzeichen oder Fehlerinformationen
   */
  sucheKennzeichen: async (request: KennzeichensucheRequest): Promise<KennzeichensucheResponse> => {
    const response = await apiClient.post<KennzeichensucheResponse>(`${BASE_URL}/suche`, request);
    return response.data;
  },

  /**
   * Vereinfachte Schnellsuche per GET (GET /api/kennzeichen/suche).
   *
   * @param unterscheidungszeichen Pflicht (z.B. B, M, HH)
   * @param erkennungszeichen Optional
   * @param erkennungsnummer Optional
   * @param maxTreffer Optional, Standard 10
   * @returns Antwort mit gefundenen Kennzeichen oder Fehlerinformationen
   */
  sucheKennzeichenGet: async (
    unterscheidungszeichen: string,
    erkennungszeichen?: string,
    erkennungsnummer?: string,
    maxTreffer: number = 10
  ): Promise<KennzeichensucheResponse> => {
    const response = await apiClient.get<KennzeichensucheResponse>(`${BASE_URL}/suche`, {
      params: {
        unterscheidungszeichen,
        erkennungszeichen,
        erkennungsnummer,
        maxTreffer
      }
    });
    return response.data;
  }
};
